import { combineReducers } from "redux";

import form from "./form";
import template from "./template";

const createJob = combineReducers({ form, template });

export default createJob;
